"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.testimonialMockWithoutStars = exports.testimonialMockWithoutImage = exports.testimonialMockWithoutData = exports.testimonialMock = exports.mockMobileImage = exports.mockDesktopImage = void 0;
const mockMobileImage = exports.mockMobileImage = 'https://placehold.co/680x385/000000/FFF?text=Mira%20bude%20důchodcem%20za%201825%20dní';
const mockDesktopImage = exports.mockDesktopImage = 'https://placehold.co/680x385/000000/FFF?text=Brebera%20je%20náš%20šampion';
const testimonialMock = exports.testimonialMock = {
  __typename: 'EditorialTestimonialCarousel',
  id: '8ce155ee-2f55-4d4b-aab9-b712d02805e1',
  collection: [{
    __typename: 'EditorialTestimonial',
    title: 'localTitle1',
    showStarRating: true,
    textCollection: [{
      __typename: 'EditorialBannerText',
      text: 'localQuote1 localQuote1 localQuote1 localQuote1 localQuote1 localQuote1 localQuote1 localQuote1 localQuote1 localQuote1 localQuote1 localQuote1 localQuote1 localQuote1 localQuote1 ',
      textLinks: []
    }],
    author: 'localAuthor1',
    image: {
      __typename: 'EditorialBannerImage',
      url: mockDesktopImage,
      urlMobile: mockMobileImage
    }
  }, {
    __typename: 'EditorialTestimonial',
    title: 'localTitle2',
    showStarRating: true,
    textCollection: [{
      __typename: 'EditorialBannerText',
      text: 'localQuote2 localQuote2 localQuote2 localQuote2 localQuote2 localQuote2 localQuote2 localQuote2 localQuote2 ',
      textLinks: []
    }],
    author: 'localAuthor2',
    image: {
      __typename: 'EditorialBannerImage',
      url: mockDesktopImage,
      urlMobile: mockMobileImage
    }
  }, {
    __typename: 'EditorialTestimonial',
    title: '',
    showStarRating: true,
    textCollection: [{
      __typename: 'EditorialBannerText',
      text: 'localQuote3 localQuote3 localQuote3 localQuote3 localQuote3 localQuote3 localQuote3 localQuote3 localQuote3 localQuote3 localQuote3 ',
      textLinks: []
    }],
    author: 'localAuthor3',
    image: {
      __typename: 'EditorialBannerImage',
      url: mockDesktopImage,
      urlMobile: mockMobileImage
    }
  }]
};
const testimonialMockWithoutStars = exports.testimonialMockWithoutStars = {
  ...testimonialMock,
  collection: testimonialMock.collection.map(item => ({
    ...item,
    showStarRating: false
  }))
};
const testimonialMockWithoutImage = exports.testimonialMockWithoutImage = {
  ...testimonialMock,
  collection: testimonialMock.collection.map(item => ({
    ...item,
    image: null
  }))
};
const testimonialMockWithoutData = exports.testimonialMockWithoutData = {
  ...testimonialMock,
  collection: []
};
